import React from 'react';
import axios from 'axios';
import { Botao, TamanhoBotao, TipoBotao, Alerta, TipoAlerta } from '@intechprev/componentes-web';

import config from "./../../config.json";

interface Props {
  PassoAtual: string;
  texto?: string;
  ListaArquivo: Array<ArquivoUploadItem>;
  setListaArquivo: any;
}

interface State {
  NomeArquivo: string;
  PassoAtual: string;
  ListaLocal: Array<ArquivoUploadItem>;
  // por algum motivo essa lista local do component resolve um problema de refencia que eu honestamento nao entendi
  Cor: string;
}

export interface ArquivoUploadItem {
  Passo: string;
  Arquivo: File;
  Oid: string;
}

export class ArquivoUpload extends React.Component<Props, State> {

  private alerta = React.createRef<Alerta>();

  private fileUpload: any;

  private apiUrl = config.apiUrl;

  constructor(props: Props) {
    super(props);

    const ListaLocal = this.props.ListaArquivo.filter(a => a.Passo === this.props.PassoAtual);

    this.state = {
      NomeArquivo: "",
      PassoAtual: this.props.PassoAtual,
      ListaLocal,
      Cor: ""
    }
  }

  MostrarAviso = (DeveMostrar: boolean) => {
    const Cor = DeveMostrar ? "alert-danger" : ""
    this.setState({
      Cor
    });
  }

  private uploadFile = async () => {
    try {
      this.alerta.current.limparErros();

      const file = this.fileUpload.files[0];

      const formData = new FormData()
      let arquivoUpload = file;

      formData.append("file", arquivoUpload, `${this.state.PassoAtual}, ${arquivoUpload.name}`)

      const app = `@${config.appName}:token`;
      const token = localStorage.getItem(app);

      // const arquivoOid = 0;
      const arquivoOid = (await axios({
        method: 'post',
        url: `${this.apiUrl}/recadastramento/Upload`,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        },
        data: formData
      })).data;

      // if(arquivoOid > 0){
      const NovoItem: ArquivoUploadItem = {
        Arquivo: arquivoUpload,
        Passo: this.state.PassoAtual + "",
        Oid: arquivoOid
      };

      this.props.setListaArquivo([...this.props.ListaArquivo, NovoItem]);

      this.setState({
        ListaLocal: [...this.state.ListaLocal, NovoItem]
      });
      // }

      this.setState({
        NomeArquivo: ""
      });

    } catch (e) {
      const err: any = e;
      const msg = err.response ? err.response.data : err;
      console.error(msg);
      this.alerta.current.adicionarErro(msg);
    }
  }

  private arquivosEnviados = () => {
    const ListaArquivoPlano = this.state.ListaLocal.filter(arquivo => arquivo.Passo = this.state.PassoAtual);
    if (ListaArquivoPlano.length > 0) {
      const nomes = ListaArquivoPlano.map((arquivo: ArquivoUploadItem, index: number) => {
        return (
          <li key={index} className={"list-group-item"}>
            {arquivo.Arquivo.name}
            <Botao
              titulo={"Cancelar envio"}
              className={"m-1"}
              tamanho={TamanhoBotao.mini}
              tipo={TipoBotao.danger}
              onClick={() => this.cancelarEnvio(arquivo)}
            />
          </li>
        );
      });
      return (
        <ul className={"list-group text-primary"}>{"Arquivos carregados:"}{nomes}</ul>
      );
    }
    return null;
  }

  private cancelarEnvio = (arquivo: ArquivoUploadItem) => {
    const l = this.props.ListaArquivo.filter(item => item !== arquivo);
    const ListaLocal = this.state.ListaLocal.filter(item => item !== arquivo);
    this.props.setListaArquivo(l);
    this.setState({
      ListaLocal
    });
    // setNomeArquivo("");
  }

  render() {
    return (
      <div className={`box ${this.state.Cor}`}>
        <div className={"box-content"}>
          <span><b>{"Atenção!"}</b></span>

          <div>{this.props.texto || "Em caso de alteração de alguma informação será necessário enviar uma cópia de um documento com foto e com o CPF."}</div>

          <input
            name={"selecionar-documento"}
            id={"selecionar-documento"}
            type={"file"}
            onChange={this.uploadFile}
            value={this.state.NomeArquivo}
            ref={(ref) => this.fileUpload = ref}
            accept={"image/tiff, image/jpeg, image/bmp, application/pdf, .png"}
          />

          <br />

          {this.arquivosEnviados()}

          <br />

          <Alerta
            tipo={TipoAlerta.danger}
            ref={this.alerta}
          />
        </div>
      </div>
    );
  }
}